import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { EmbedData } from '../../data/embed';
import { Subject, take, takeUntil } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { EmbedService } from '../../../../embed-layout/common/services/embed.service';
import { ThreeGraphqlService } from 'src/app/core/graphql/three/services/three-graphql.service';
import { UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'project-selecte-tool',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './project-selecte-tool.component.html',
  styleUrl: './project-selecte-tool.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectSelecteToolComponent implements OnInit, OnDestroy {
  public companyUuid: string = '';

  public templates: Array<any> = [];
  public embedData: EmbedData | undefined;

  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private threedGraphicService: ThreeGraphqlService,
    private embedService: EmbedService,
    private userSerivce: UserService,

    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.getEmbedData();
    this.getTemplates();
    this.getCompanyProjectList();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public onSelectedTemplate(template: any): void {
    if (!this.embedData) return;
    this.threedGraphicService
      .createEmbedProject(template.uuid, this.embedData.uuid)
      .pipe(take(1))
      .subscribe((project: any) => {
        const embedData = this.embedData;
        if (!embedData) return;
        this.embedData?.projects.push(project);
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
  }

  public onClickDeteleteProject(project: any): void {
    if (!this.embedData) return;
    this.threedGraphicService
      .deleteEmbedProject(project.uuid)
      .pipe(take(1))
      .subscribe((res: any) => {
        if (!res.data.embedProjectDelete.success) return;
        const embedData = this.embedData;
        if (!embedData) return;
        if (!this.embedData) return;
        this.embedData.projects = this.embedData.projects.filter(
          (item) => item.uuid !== project.uuid,
        );
        this.embedService.embedData = this.embedData;
        this.cd.markForCheck();
      });
  }

  public includeProject(templete: any): boolean {
    if (!this.embedData) return false;
    if (!this.embedData.projects) return false;
    if (this.embedData.projects.length === 0) return false;
    return (
      this.embedData.projects.filter((project) => project.template?.uuid === templete?.uuid)
        .length > 0
    );
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------

  private getEmbedData(): void {
    this.embedService.embedData$
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((embedData: EmbedData | undefined) => {
        if (!embedData) return;
        this.embedData = embedData;
        this.cd.markForCheck();
      });
  }
  private getTemplates(): void {
    this.threedGraphicService
      .getTempletes(50)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((res) => {
        this.templates = res;
        this.cd.markForCheck();
      });
  }

  private getCompanyProjectList(): void {
    if (!this.userSerivce.email) return;
    this.threedGraphicService
      .getCompanyProjects(this.userSerivce.email)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe((company: any) => {
        this.companyUuid = company.uuid;
      });
  }
}
